// 导入封装好的网络请求类工具
import Network from './network';

// 封装各种接口请求
// export const 接口名 = () => Network.get('/路由',参数对象);

export default {
	UserLogin: (argdata) => Network.post('/api/UserInfo/Login_Web', argdata),
	CheckUserauth: (argdata) => Network.get('/api/userinfo/checktoken', argdata),
	GetFuns: (argdata) => Network.get('/api/SysFun/GetUserFunTree', argdata),

	Login: (argdata) => Network.post('/api/User/Login', argdata),
	Logout: (argdata) => Network.get('/api/User/Logout', argdata),
	UserList: (argdata) => Network.post('/api/User/List', argdata),
	UserDetail: (argdata) => Network.get('/api/User/Detail', argdata),
	AddUser: (argdata) => Network.post('/api/User/Add', argdata),
	ChangeUserPassword: (argdata) => Network.post('/api/User/ResetPassword', argdata),
	RemoveUser: (argdata) => Network.post('/api/User/Remove', argdata),

	GetHoldTree: (argdata) => Network.get('/api/Hold/GetHoldTree', argdata),

	SimList: (argdata) => Network.post('/api/Sim/List', argdata),
	AddSim: (argdata) => Network.post('/api/Sim/Add', argdata),
	SimDetail: (argdata) => Network.get('/api/Sim/Detail', argdata),
	SimDetail2: (argdata) => Network.get('/api/Sim/Detail2', argdata),
	PackageOptions: (argdata) => Network.get('/api/PackageInfo/Options', argdata),
	SourceOptions: (argdata) => Network.get('/api/SourceInfo/Options', argdata),
	RemoveSim: (argdata) => Network.post('/api/Sim/Remove', argdata),
	AllocateSims: (argdata) => Network.post('/api/Sim/MigrationSims', argdata),
	LoadPkgSourceOptions: (argdata) => Network.get('/api/Sim/PkgSourceOptions', argdata),
	ImportSimsByIccids: (argdata) => Network.post('/api/Sim/Import_ICCIDs', argdata),
	ImportSimsByExcel: (argdata) => Network.post('/api/Sim/Import_Excel', argdata),
	InsyncSingleCard: (argdata) => Network.get('/api/Sim/InsyncSingleCard', argdata),
	InsyncMultipleCards: (argdata) => Network.post('/api/Sim/InsyncMultipleCards', argdata),
	GetRenewablePkgList: (argdata) => Network.get('/api/Sim/RenewablePkgList', argdata),
	ChangeSimStatus: (argdata) => Network.post('/api/Sim/ChangeStatus', argdata),
	CardRechargePkg: (argdata) => Network.post('/api/Sim/CardRechargePkg', argdata),
	GetPurchasedPkgList: (argdata) => Network.get('/api/Sim/PurchasedPkgList', argdata),
	InsyncMultipleSimBossCards: (argdata) => Network.post('/api/Sim/InsyncMultipleSimBossCards', argdata),
	// SimBoss卡续费
	SimbossRenewablePkgList: (argdata) => Network.get('/api/Sim/SimbossRenewablePkgList', argdata),
	SimbossRechargePkg: (argdata) => Network.post('/api/Sim/SimbossRechargePkg', argdata),
	SimBossPurchasedPkgList: (argdata) => Network.get('/api/Sim/SimBossPurchasedPkgList', argdata),
	// 批量设置标签
	BatchSetTag1: (argdata) => Network.post('/api/Sim/BatchSetTag1', argdata),
	BatchSetTag2: (argdata) => Network.post('/api/Sim/BatchSetTag2', argdata),

	HoldList: (argdata) => Network.post('/api/Hold/List', argdata),
	HoldDetail: (argdata) => Network.get('/api/Hold/Detail', argdata),
	AddHold: (argdata) => Network.post('/api/Hold/Add', argdata),
	RemoveHold: (argdata) => Network.post('/api/Hold/Remove', argdata),

	CardSourceList: (argdata) => Network.post('/api/SourceInfo/List', argdata),
	CardSourceDetail: (argdata) => Network.get('/api/SourceInfo/Detail', argdata),
	AddCardSource: (argdata) => Network.post('/api/SourceInfo/Add', argdata),
	RemoveCardSource: (argdata) => Network.post('/api/SourceInfo/Remove', argdata),

	PackageInfoList: (argdata) => Network.post('/api/PackageInfo/List', argdata),
	PackageDetail: (argdata) => Network.get('/api/PackageInfo/Detail', argdata),
	AddPackageInfo: (argdata) => Network.post('/api/PackageInfo/Add', argdata),
	RemovePackageInfo: (argdata) => Network.post('/api/PackageInfo/Remove', argdata),
	QueryPkgOptionItems: (argdata) => Network.get('/api/PackageInfo/QueryPkgOptionItems', argdata),
	AddPkgPrice: (argdata) => Network.post('/api/PkgPriceConfig/Add', argdata),
	PkgPriceList: (argdata) => Network.post('/api/PkgPriceConfig/List', argdata),
	PkgPriceDetail: (argdata) => Network.get('/api/PkgPriceConfig/Detail', argdata),
	SetPkgPriceStatus: (argdata) => Network.get('/api/PkgPriceConfig/SetStatus', argdata),
	RemovePkgPrice: (argdata) => Network.post('/api/PkgPriceConfig/Remove', argdata),
	/* SIM卡套餐续费权限 */
	GetSelPkgItems: (argdata) => Network.get('/api/PkgRechargeList/SelPkgItems', argdata),
	AddPkgRechargeList: (argdata) => Network.post('/api/PkgRechargeList/Add', argdata),
	PkgRechargeListManage: (argdata) => Network.post('/api/PkgRechargeList/Manage', argdata),

	GetDetailItems: (argdata) => Network.get('/api/Dictionary/Items', argdata),
	GetDetailMultipleItems: (argdata) => Network.get('/api/Dictionary/MultipleItems', argdata),

	SMSList: (argdata) => Network.post('/api/SMS/List', argdata),
	GenerateSMS: (argdata) => Network.post('/api/SMS/Generate', argdata),

	SysLogsList: (argdata) => Network.post('/api/SysLogs/List', argdata),

	AddApiUser: (argdata) => Network.post('/api/ApiUser/Add', argdata),
	ApiUserList: (argdata) => Network.post('/api/ApiUser/List', argdata),
	ApiUserDetail: (argdata) => Network.get('/api/ApiUser/Detail', argdata),
	HandleEnableApiUser: (argdata) => Network.get('/api/ApiUser/HandleEnable', argdata),
	RemoveApiUser: (argdata) => Network.post('/api/ApiUser/Remove', argdata),
	GenerateKeySecret: (argdata) => Network.get('/api/ApiUser/GenerateKeySecret', argdata),

	/* 国际卡管理 */
	GMSimsAdd: (argdata) => Network.post('/api/GMSims/Add', argdata),
	GMSimsList: (argdata) => Network.post('/api/GMSims/List', argdata),
	GMSimsExports: (argdata) => Network.post('/api/GMSims/List', argdata),
	OperatorPkgOptions: (argdata) => Network.get('/api/PackageInfo/OperatorPkgOptions', argdata),
	GMInsyncMultipleCards: (argdata) => Network.post('/api/GMSims/InsyncMultipleCards', argdata),
	GMSimDetail: (argdata) => Network.get('/api/GMSims/Detail', argdata),
	GMUsageByThreeMonth: (argdata) => Network.get('/api/GMSims/UsageByThreeMonth', argdata),

	/* 续订套餐 */
	BuildRenewalsOrder: (argdata) => Network.post('/api/RenewalsNativeOrder/Build', argdata),
	RenewalsOrderList: (argdata) => Network.post('/api/RenewalsOrder/List', argdata),
	RenewalsOrderSimDetail: (argdata) => Network.get('/api/RenewalsOrder/SimList', argdata),
	ExportOrderList: (argdata) => Network.post('/api/RenewalsOrder/Exports', argdata),
}